import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';
import type { BroadcastDto } from '@shared/types';

/**
 * Lazy-fetch broadcast pro daný feed_item. Hook se aktivuje jen když enabled=true,
 * což FeedCard nastaví, když broker rozbalí broadcast panel.
 *
 * On-demand generování může trvat ~5-10s (Sonnet call) když to je první open.
 * Subsequent opens jsou cached → ~50ms.
 */
export function useBroadcast(feedItemId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['broadcast', feedItemId],
    enabled,
    staleTime: 60 * 60 * 1000, // 1h — broadcast se po vytvoření nemění
    retry: (failureCount, err) => {
      if (err instanceof ApiError && (err.status === 412 || err.status === 503)) return false;
      return failureCount < 1;
    },
    queryFn: async () => (await api.get<{ data: BroadcastDto }>(`/broadcasts/${feedItemId}`)).data,
  });
}
